module.exports = __webpack_public_path__ + "static/media/vapor-barrier@2x.723b7473.jpg";